import { Component, OnInit } from '@angular/core';
import { AuditEntry, HuntApiService } from '../hunt-api.service';
import { accessMessage } from '../hunt-errors';

const ACTION_LABELS: { [k: string]: string } = {
  state: 'Changed hunt state',
  settings: 'Changed settings',
  import: 'Imported bones',
  schedule: 'Scheduled bones',
  unschedule: 'Cleared slots',
  bone_update: 'Edited a bone',
  bone_delete: 'Deleted a bone',
  void_claim: 'Voided a find',
  reset: 'Reset the hunt',
  admin_add: 'Added a hunt admin',
  admin_remove: 'Removed a hunt admin',
  admins: 'Changed hunt admins',
};

@Component({
  selector: 'app-hunt-activity',
  templateUrl: './hunt-activity.component.html',
  styleUrls: ['./hunt-activity.component.scss'],
})
export class HuntActivityComponent implements OnInit {
  entries: AuditEntry[] = [];
  loading = true;
  error = '';
  open: string | null = null;

  constructor(private api: HuntApiService) {}

  ngOnInit() {
    this.api.audit(200).subscribe(
      (r) => { this.entries = r.entries; this.loading = false; },
      (e) => { this.error = accessMessage(e); this.loading = false; },
    );
  }

  label(a: string) { return ACTION_LABELS[a] || a; }

  /** One-line summary of what changed, from the stored details. */
  summary(e: AuditEntry): string {
    const d = e.details || {};
    const body = d.body || d;
    const res = d.result || {};
    switch (e.action) {
      case 'state': return body.action ? `${body.action}${res.shiftedBones ? ` (moved ${res.shiftedBones} bones)` : ''}` : '';
      case 'import': return res.dryRun ? 'Preview only' : `${res.saved != null ? res.saved : body.saved} saved`;
      case 'schedule': return body.dryRun ? 'Preview only' : `${(res.scheduled && res.scheduled.length) || body.count || ''} slots`;
      case 'bone_update': case 'bone_delete': return d.params ? `Bone #${d.params.n}` : '';
      case 'void_claim': return `${(d.params && d.params.code) || body.code || ''} ${body.reason ? `· ${body.reason}` : ''}`;
      case 'admin_add': return body.email || '';
      case 'admin_remove': return (d.params && d.params.email) || '';
      case 'reset': return `${body.scope || res.reset || ''}${body.unschedule || res.unscheduled ? ' + slots' : ''}`;
      default: return '';
    }
  }

  json(v: any) { return JSON.stringify(v, null, 2); }
}
